import { firestore } from "../firebase/firebase";
import { getFirestore, collection, addDoc } from "firebase/firestore";

export const triggerEmail = async (
  email: String,
  name: String,
  content: String
) => {
  const emailData = {
    to: email,
    message: {
      subject: "rippl.sg contact us",
      html: `
            <!DOCTYPE html>
            <html>
                <head>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                            padding: 0;
                            color: #333;
                        }
                        .header {
                            color: #0066CC;
                            margin-bottom: 20px;
                        }
                        .content {
                            margin-bottom: 20px;
                        }
                        .footer {
                            font-size: 0.9em;
                            color: #666;
                        }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <h1>Thank You for Your Feedback, ${name}!</h1>
                    </div>
                    <div class="content">
                        <p>This is a computer-generated email to confirm that you have sent feedback via our Contact Us form. We will look into it as soon as possible.</p>
                        <p><strong>Your message:</strong></p>
                        <p>${content}</p>
                    </div>
                    <div class="footer">
                        <p>Regards,</p>
                        <p>rippl.sg Team</p>
                    </div>
                </body>
            </html>
            `,
    },
  };

  try {
    const docRef = await addDoc(collection(firestore, "mail"), emailData);
    console.log("Email trigger added to Firestore with ID:", docRef.id);
  } catch (error) {
    console.error("Error adding email trigger:", error);
  }
};
